const css = `._6HLW5q__base{font-weight:var(--typography-fw-base)}._6HLW5q__semibold{font-weight:var(--typography-fw-semibold)}._6HLW5q__medium{font-weight:var(--typography-fw-medium)}._6HLW5q__light{font-weight:var(--typography-fw-light)}._6HLW5q__bold{font-weight:var(--typography-fw-bold)}._6HLW5q__regular{font-weight:var(--typography-fw-regular)}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"base":"_6HLW5q__base","light":"_6HLW5q__light","semibold":"_6HLW5q__semibold","medium":"_6HLW5q__medium","bold":"_6HLW5q__bold","regular":"_6HLW5q__regular"};
